class BannerCarousel extends HTMLElement {
  constructor() {
    super();

    this.swiperEl = this.querySelector(".banner-carousel-swiper");
    this.swiperSlides = this.swiperEl.querySelectorAll(".swiper-slide");
    this.swiperSlideFirst = this.swiperSlides[0];
    this.swiperNext = this.querySelector('.banner-button-next')
    this.swiperPrev = this.querySelector('.banner-button-prev')
    this.swiperPagination = this.querySelector('.swiper-pagination')
    this.autoplay = this.hasAttribute('data-autoplay')
    this.duration = this.getAttribute('data-duration') || 5000
  }

  connectedCallback() {
    const options = {
      spaceBetween: 20,
      centeredSlides: true,
      slidesPerView: 1.3,
      speed: 400,
      loop: true,
      navigation: {
        nextEl: this.swiperNext,
        prevEl: this.swiperPrev
      },
      pagination: {
        el: this.swiperPagination,
        clickable: true
      }
    };

    if (this.autoplay) {
      options.autoplay = {
        delay: this.duration
      }
    }

    const swiperInstance = new window.Swiper(this.swiperEl, options);

    this.pauseAllVideo();
    const videoFirst = this.swiperSlideFirst.querySelector("video-player");
    if (videoFirst) {
      this.handlePlayVideo(videoFirst.getAttribute("data-type"), videoFirst);
    }

    swiperInstance.on("slideChange", (swiper) => {
      const slideActive = swiper.slides[swiper.activeIndex];
      const videosCurrentActive = slideActive.querySelectorAll("video-player");
      this.pauseAllVideo();

      videosCurrentActive.forEach((video) => {
        const type = video.getAttribute("data-type");
        this.handlePlayVideo(type, video);
      })
    });
  }

  pauseAllVideo() {
    const allVideos = this.querySelectorAll("video-player");

    allVideos.length > 0 &&
      allVideos.forEach((video) => {
        const type = video.getAttribute("data-type");
        this.handlePauseVideo(type, video);
      });
  }

  async handlePauseVideo(type, el) {
    await customElements.whenDefined("video-player");

    if (typeof el.pause !== "function" || typeof el.vimeoPause !== 'function' || typeof el.youtubePause !== 'function') return;
    switch (type) {
      case "youtube":
        el.youtubePause();
        break;
      case "vimeo":
        el.vimeoPause();
        break;
      case "mp4":
        el.pause();
        break;
      default:
        break;
    }
  }

  async handlePlayVideo(type, el) {
    await customElements.whenDefined("video-player");

    if (typeof el.play !== "function" || typeof el.vimeoPlay !== 'function' || typeof el.youtubePlay !== 'function') return;
    switch (type) {
      case "youtube":
        el.youtubePlay();
        break;
      case "vimeo":
        el.vimeoPlay();
        break;
      case "mp4":
        el.play();
        break;
      default:
        break;
    }
  }
}

if (!customElements.get("banner-carousel")) {
  customElements.define("banner-carousel", BannerCarousel);
}
